import React from 'react';
import { SectionTitleWrapper } from './SectionTitle.styles';

const SectionTitle = ({ children, ...restProps }) => {
  return <SectionTitleWrapper {...restProps}>{children || 'No hay texto'}</SectionTitleWrapper>; //eslint-disable-line
};

export default SectionTitle;
